// extracted by mini-css-extract-plugin
var _1 = "buttons--peKt0QsI";
var _2 = "close--lahtvsmQ";
var _3 = "errorText--jQDjzU9s";
var _4 = "panel--dgl9E_cP";
export { _1 as "buttons", _2 as "close", _3 as "errorText", _4 as "panel" }
